import React from "react";
import { useLocation } from "react-router-dom";
import "./Sidebar.css";
import { FaUser, FaHistory, FaCalendarAlt, FaFolder } from "react-icons/fa";

function Sidebar() {
  const location = useLocation();

  return (
    <aside className="sidebar">
      <nav>
        <a href="/profile" className={location.pathname === "/profile" ? "active" : ""}>
          <FaUser className="icon" />
          <span>My Profile</span>
        </a>
        <a href="/history" className={location.pathname === "/history" ? "active" : ""}>
          <FaHistory className="icon" />
          <span>History</span>
        </a>
        {/* Subscription removed */}
        <a href="/appointments" className={location.pathname === "/appointments" ? "active" : ""}>
          <FaCalendarAlt className="icon" />
          <span>Appointments</span>
        </a>
        <a href="/client-folder" className={location.pathname === "/client-folder" ? "active" : ""}>
          <FaFolder className="icon" />
          <span>My Folder</span>
        </a>
      </nav>
    </aside>
  );
}

export default Sidebar;
